import './favourability.scss';
import ReactECharts from 'echarts-for-react';
import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'redux/reducers';
import { ClipType, RootState } from 'types';

function Favourability({
    clips,
}: {
    clips: ClipType[]
}) {
    const coreState = useSelector((state: RootState) => state.core);
    const dispatch = useDispatch();
    const [chartData, setChartData] = useState<object[]>(
        [
            {
                name: 'Positive',
                value: null,
                itemStyle: {
                    color: '#00C851'
                }
            },
            {
                name: 'Neutral',
                value: null,
                itemStyle: {
                    color: '#c9d3e1'
                }
            },
            {
                name: 'Negative',
                value: null,
                itemStyle: {
                    color: '#ff4444'
                }
            }
        ]
    );

    const getData = useCallback(async () => {

        var chartData: object[] = [];
        coreState.Favourability.forEach(element => {
            chartData.push({
                name: element.Description,
                value: clips.filter((x: ClipType) => x.FavourabilityId === element.Id) ? clips.filter((x: ClipType) => x.FavourabilityId === element.Id).length : 0,
                itemStyle: {
                    color: element.Color
                }
            })
        });
        setChartData(chartData);
    }, [clips, coreState.Favourability])

    const onClick = useCallback(async (e: any) => {
        e.event.stop();
        dispatch(actions.clipTray.set({
            loading: true,
            clips: [],
            open: true,
        }))
        let data = [...clips];
        var selected = coreState.Favourability.find(x => x.Description === e.name);
        data = data.filter(x => x.FavourabilityId === selected?.Id);

        dispatch(actions.clipTray.set({
            clips: data,
            open: true,
            loading: false
        }))
    }, [dispatch, clips, coreState.Favourability])

    useEffect(() => {
        getData();
    }, [getData])

    return (
        <div className="favourability">
            <div className="top">
                <p>Favourability</p>
            </div>
            <div className="body">
                <ReactECharts
                    style={{height: 450}}
                    option={{
                        tooltip: {
                            trigger: 'item',
                            formatter: '{a} <br/>{b}: {c} ({d}%)'
                        },
                        legend: {
                            data: coreState.Favourability.filter(x => x.Description === "Postive" || "Negative" || "Neutral").map(x => x.Description)
                        },
                        series: [
                            {
                                name: "Favourability",
                                type: "pie",
                                radius: ['50%', '75%'],
                                avoidLabelOverlap: false,
                                label: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    label: {
                                        show: true,
                                        fontWeight: 'bold'
                                    }
                                },
                                labelLine: {
                                    show: false
                                },
                                data: chartData
                            }
                        ]
                    }
                    }
                    notMerge={true}
                    lazyUpdate={true}
                    onEvents={{
                        'click': onClick
                    }}
                />
            </div>
        </div>
    )
}

export default Favourability;